﻿(() => {
  const onReady = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
      return;
    }
    fn();
  };

  onReady(() => {
    const scheduleNonCritical = (fn) => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(fn, { timeout: 1500 });
        return;
      }
      window.setTimeout(fn, 250);
    };

    scheduleNonCritical(() => {
      document.querySelectorAll('[data-mobile-submenu-toggle]').forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const target = document.querySelector(`#${toggle.getAttribute('data-mobile-submenu-toggle')}`);
          if (target) {
            target.classList.toggle('is-open');
          }
        });
      });

      const flyoutRoot = document.querySelector('[data-shop-flyout-root]');
      const flyoutToggle = document.querySelector('[data-shop-flyout-toggle]');
      if (flyoutRoot && flyoutToggle) {
        // Open flyout on hover (desktop) — click navigates to /collections/all
        flyoutRoot.addEventListener('mouseenter', () => {
          flyoutRoot.classList.add('is-open');
        });
        flyoutRoot.addEventListener('mouseleave', () => {
          flyoutRoot.classList.remove('is-open');
        });

        // Mobile: toggle on click without preventing navigation on second tap
        flyoutToggle.addEventListener('click', (event) => {
          if (window.innerWidth < 768) {
            event.preventDefault();
            flyoutRoot.classList.toggle('is-open');
          }
          // Desktop: allow natural link navigation (no preventDefault)
        });

        document.addEventListener('click', (event) => {
          if (!flyoutRoot.contains(event.target)) {
            flyoutRoot.classList.remove('is-open');
          }
        });
      }

      // Header scroll-depth recede
      const siteHeader = document.querySelector('.site-header--monolith');
      if (siteHeader) {
        let headerTicking = false;
        let scrollThreshold = window.innerHeight * 0.6;
        window.addEventListener(
          'resize',
          () => {
            scrollThreshold = window.innerHeight * 0.6;
          },
          { passive: true }
        );
        window.addEventListener(
          'scroll',
          () => {
            if (!headerTicking) {
              window.requestAnimationFrame(() => {
                siteHeader.classList.toggle('is-scrolled-deep', window.scrollY > scrollThreshold);
                siteHeader.classList.toggle('cx-header--scrolled', window.scrollY > 80);
                headerTicking = false;
              });
              headerTicking = true;
            }
          },
          { passive: true }
        );
      }

      const animatedNodes = Array.from(document.querySelectorAll('.animate-fade, .vesper-reveal'));
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (animatedNodes.length > 0 && 'IntersectionObserver' in window && !prefersReducedMotion) {
        const seenNodes = new WeakSet();
        // Track nodes that had is-visible hardcoded in HTML — never strip these
        const initiallyVisible = new WeakSet();
        animatedNodes.forEach((node) => {
          if (node.classList.contains('is-visible')) {
            initiallyVisible.add(node);
            seenNodes.add(node);
          }
        });
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const node = entry.target;

              if (entry.isIntersecting) {
                node.classList.add('is-visible');
                seenNodes.add(node);
                observer.unobserve(node);
                return;
              }

              // Only remove is-visible if it was NOT hardcoded in HTML
              if (!seenNodes.has(node) && !initiallyVisible.has(node)) {
                node.classList.remove('is-visible');
              }
            });
          },
          { threshold: 0.05, rootMargin: '0px 0px 60px 0px' }
        );

        animatedNodes.forEach((node) => {
          observer.observe(node);
        });
      } else {
        animatedNodes.forEach((node) => node.classList.add('is-visible'));
      }

      document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
        const wrapper = gallery.closest('.product-gallery');
        if (!wrapper) return;

        const dots = Array.from(wrapper.querySelectorAll('[data-gallery-dot]'));
        if (dots.length === 0) return;

        const setActiveDot = (index) => {
          dots.forEach((dot, dotIndex) => {
            const isActive = dotIndex === index;
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-current', isActive ? 'true' : 'false');
          });
        };

        dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const targetIndex = Number(dot.getAttribute('data-gallery-dot'));
            const targetSlide = gallery.querySelector(`[data-slide-index="${targetIndex}"]`);
            if (!targetSlide) return;
            gallery.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
            setActiveDot(targetIndex);
          });
        });

        gallery.addEventListener(
          'scroll',
          () => {
            const index = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
            setActiveDot(Math.max(0, Math.min(index, dots.length - 1)));
          },
          { passive: true }
        );
      });
    });
  });
})();
